import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100% - 10px);
  background-color: ${({ theme }) => theme.name === 'dark' ? theme.colors.White : theme.colors.Gray10};
  margin-top: 5px;
`;
